<div class="card">
	<div class="card-header">
		<h1>Convertir Clientes a Afiliados<span>
			<!-- <i class="clickeable fa fa-plus" (click)="create()"></i> -->
		</span></h1>
	</div>
	<div class="card-body">
		<div class="form-group">
			<label for="filter" class="form-label">Busca por Código/Nombre/NIT</label>
			<input type="text" name="filter" id="filter" (input)="filtering()" [(ngModel)]="filter"
				placeholder="Ingresa un código, nombre o nit" class="form-control">
		</div>
		<div class="table-responsive" style="margin-top: 1em;">
			<table class="table table-bordered" style="margin: 0;">
				<thead>
					<tr>
						<th class="td-center">
							Afiliado
						</th>
						<th>
							Nombre
						</th>
						<th>
							NIT
						</th>
						<th>
							Código
						</th>
						<th>

						</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let vendor of pagination.filter">
						<td class="td-center">
							<i *ngIf="!converting[vendor.nit] && vendor['affiliateData'] && vendor.id"
								tooltip="Activa/Desactiva estado del afiliado" (click)="convert(vendor)"
								[ngClass]="vendor.affiliate?'fa-toggle-on text-success a-hover':'fa-toggle-off clickeable'"
								class="fa"></i>
							<span *ngIf="converting[vendor.nit]"
								[ngClass]="vendor.affiliate?'text-secondary':'text-success'"
								class="spinner-border spinner-border-sm"></span>
							<i *ngIf="!vendor.id && vendor['affiliateData']"
								tooltip="Este registro es unicamente afiliado, no se puede desactivar"
								style="opacity: 0.8;" class="fa fa-toggle-on text-success only-affiliate"></i>
							<i *ngIf="!vendor['affiliateData'] && vendor.id" class="fa fa-circle-info text-secondary"
								style="opacity: 0.5;" tooltip="Crea un afiliado para este cliente"></i>
						</td>
						<td>
							{{vendor.name}}
						</td>
						<td>
							{{vendor.nit}}
						</td>
						<td>
							{{vendor.code}}
						</td>
						<td class="td-center">
							<i [ngClass]="vendor['affiliateData']?'fa-edit':'fa-plus'" class="fa clickeable text-info"
								(click)="edit(vendor)"></i>
						</td>
					</tr>
					<tr *ngIf="pagination.filter.length == 0">
						<td colspan="5" class="td-center">
							<i class="fa fa-circle-info"></i>
							{{vendors.length == 0?'Aún no se han agregado clientes ni afiliados':'No se encuentran resultados para '}}
							<b>{{vendors.length > 0 && filter?filter:''}}</b>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<app-pagination-custom [elements]="pagination"></app-pagination-custom>
	</div>
</div>
<app-modal-create-affiliate *ngIf="modalShowing" [isCreating]="isCreating" [affiliate]="affiliateEditing"
	(close)="close($event)"></app-modal-create-affiliate>